import { buildAction } from 'store/actions/actionCreator'

import {
  FETCH_CHANNELS_FLOORSPACE,
  FETCH_CHANNELS_FLOORSPACE_ERROR,
  FETCH_CHANNELS_FLOORSPACE_SUCCESS,
  SET_SORT,
} from './constants'

export const channelsFloorspaceError = buildAction(FETCH_CHANNELS_FLOORSPACE_ERROR)

export const channelsFloorspaceSuccess = buildAction(FETCH_CHANNELS_FLOORSPACE_SUCCESS, 'payload')

export const fetchChannelsFloorspace = buildAction(FETCH_CHANNELS_FLOORSPACE)

export const setSort = buildAction(SET_SORT, 'payload')
